import * as React from "react";

function FeatureCard({ image, altText, title, description }) {
  return (
    <article className="flex flex-col p-8 bg-white rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.08)] max-sm:p-2">
      <div className="mb-2">
        <img
          src={image}
          alt={altText}
          className="w-full h-auto"
        />
      </div>
      <h3 className="mb-3 text-2xl font-semibold leading-tight text-teal-600 max-sm:text-xl">
        {title}
      </h3>
      <p className="text-base leading-relaxed text-gray-500 max-sm:text-sm">
        {description}
      </p>
    </article>
  );
}

export default FeatureCard;
